module.exports = __webpack_public_path__ + "img/13_BIS_demontage_dattier.3ace6b6f.jpg";